const loadingDialog = require("./loadingDialog");
const appendToBody = require("../dom/appendToBody");
const showDialog = require("../dom/showDialog");

/**
 * @return {HTMLDialogElement}
 */
module.exports = function showLoadingDialog() {
    const loadingDialog$ = loadingDialog();

    appendToBody(loadingDialog$);

    showDialog(loadingDialog$);

    return loadingDialog$;
}
